import React, { Fragment, useState } from 'react';
import { Row, Col, Table } from 'reactstrap';
import moment from 'moment';
import SweetAlert from 'sweetalert2';
import { toast } from 'react-toastify';
import ViewCommunicationDetailMessageModal from './modal-in-modal/view-communication-detail-message';
import formatedDateOnly from '../../../../../utilities/formatedDateOnly';
import { initiateCustomerRefundPayment } from '../../../../../api';
import { getFromLocalStorage } from '../../../../../hooks/useLocalStorage';
// import CommunicationMsgModal from './modal-in-modal/communication-details-msg';
// import CommunicationWhatsAppModal from './modal-in-modal/communication-details-whatsapp';


const CommunicationDetails = ({ data = [], documentStatus = '', documentId = null, documentUniqueCode = '', onRefresh }) => {

    const [viewCommunicationDetailMessageModal, setViewCommunicationDetailMessageModal] = useState(false);
    const toggleViewCommunicationDetailMessageModal = () => setViewCommunicationDetailMessageModal(!viewCommunicationDetailMessageModal);

    // const [viewCommunicationDetailWhatsappModal, setViewCommunicationDetailWhatsappModal] = useState(false);
    // const toggleViewCommunicationDetailWhatsappModal = () => setViewCommunicationDetailWhatsappModal(!viewCommunicationDetailWhatsappModal);

    // const [viewCommunicationModal, setViewCommunicationModal] = useState(false);
    // const toggleViewCommunicationModal = () => setViewCommunicationModal(!viewCommunicationModal);

    // const [viewCommunicationEmailModal, setViewCommunicationEmailModal] = useState(false);
    // const toggleViewCommunicationEmailModal = () => setViewCommunicationEmailModal(!viewCommunicationEmailModal);

    const [dataByType, setDtaByType] = useState();
    const [submittingRefundTxnId, setSubmittingRefundTxnId] = useState(null);
    const hasCustomerRefundPayment = data?.some((entry) => entry?.TYPE === 'CUSTOMER_REFUND_PAYMENT');
    const isCancelledDocument = String(documentStatus || '').toUpperCase() === 'CANCELLED';
    const [isHO] = useState(getFromLocalStorage('ROLE')?.key == "HO" ? true : false);
    const viewPolicy = (entry) => {
        setDtaByType(entry);
        toggleViewCommunicationDetailMessageModal();
    }

    const handleInitiateRefund = async (item) => {
        const row = item?.row || {};
        const transactionKey = row?.document_transaction_history_id || row?.txnid || row?.txnId || 'NA';

        const confirmation = await SweetAlert.fire({
            title: 'Initiate refund?',
            text: `Refund will be initiated for document ${documentUniqueCode || documentId || ''}`.trim(),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, initiate',
            cancelButtonText: 'No',
            reverseButtons: true,
        });

        if (!confirmation.isConfirmed) return;

        try {
            setSubmittingRefundTxnId(transactionKey);
            const response = await initiateCustomerRefundPayment({
                document_unique_code: documentUniqueCode || ''
            });
            const successMsg = response?.data?.result?.msg || response?.data?.msg || 'Refund initiated successfully';
            toast.success(successMsg);
            if (typeof onRefresh === 'function') {
                await onRefresh();
            }
        } catch (err) {
            toast.error(err?.response?.data?.error || 'Unable to initiate refund');
        } finally {
            setSubmittingRefundTxnId(null);
        }
    };

    const safeParseJson = (value) => {
        if (!value) return null;
        if (typeof value === 'object') return value;
        if (typeof value !== 'string') return null;

        try {
            const parsed = JSON.parse(value);
            if (typeof parsed === 'string') {
                try {
                    return JSON.parse(parsed);
                } catch (_e) {
                    return null;
                }
            }
            return parsed;
        } catch (_e) {
            try {
                const sanitized = value.replace(/^(\d+)/, '"$1"');
                return JSON.parse(sanitized);
            } catch (__e) {
                return null;
            }
        }
    };

    const formatDeliveredAt = (entry, messageBody) => {
        const deliveredCandidate = entry?.send_at || messageBody?.doneAt || messageBody?.sentAt || entry?.updatedAt || null;
        if (!deliveredCandidate) return '-';
        const m = moment(deliveredCandidate);
        return m.isValid() ? m.format('DD-MMM-yyyy hh:mm A') : '-';
    };

   


    const createArrayOfLists = (data) => {
        const hasCustomerPayment = data?.some((entry) => entry?.TYPE === 'CUSTOMER_PAYMENT');

        // const listOfItems = data?.filter(entry => entry.TYPE === 'EMAIL' || entry.TYPE === 'SMS' || entry.TYPE === 'WHATSAPP' ).map((entry, index) => {
        const listOfItems = data.map((entry, index) => {
            const txnData = safeParseJson(entry?.txnId) || {};
            const bodyData = safeParseJson(entry?.body) || {};
            const messageBody = Object.keys(txnData).length > 0 ? txnData : bodyData;
    
            let message = 'NA';
            let statusName = 'NA';
            if(entry.TYPE == 'EMAIL'){
                message = messageBody?.messages ? messageBody?.messages[0] : ''; // Assuming there's only one message
                statusName = entry?.status ? entry?.status : 'NA';
            }else if(entry.TYPE == 'SMS'){
                message = messageBody?.messages ? messageBody?.messages[0] : ''; // Assuming there's only one message
                statusName = entry?.status ? entry?.status : 'NA';
            }else if(entry.TYPE == 'WHATSAPP'){
                message = messageBody?.result ? 'DELIVERED' : ''; // Assuming there's only one message
                statusName = message ? message : 'NA';
            }else if(entry.TYPE == 'CUSTOMER_PAYMENT'){
                // Refund is considered not initiated only when document is cancelled,
                // customer payment exists, and refund payment history is absent.
                if (isCancelledDocument && hasCustomerPayment && !hasCustomerRefundPayment) {
                    statusName = 'REFUND_NOT_INITIATED';
                } else {
                    statusName = entry?.status ? entry?.status : 'NA';
                }
            } 
            else {
                  message = messageBody?.messages ? messageBody?.messages[0] : ''; 
                  
                  statusName = entry?.status ? entry?.status : 'NA';
            }
    
            return {
                transactionId: entry.policy_transaction_history_id,
                type: entry.TYPE,
                status: convertToTitleCase(normalizeLabel(statusName)),
                mihpayid: messageBody?.mihpayid || bodyData?.mihpayid || txnData?.mihpayid || '-',
                transactionIdForRefund: messageBody?.txnid || bodyData?.txnid || txnData?.txnid || '-',
                body: entry.body,
                createdDate: moment(entry.created_date).format("DD MMM, yyyy hh:mm A"),
                deliveredAtDate: formatDeliveredAt(entry, messageBody),
                row: entry
            };
        });
    
        return listOfItems;
    };
    
    
    
    
    const arrayOfLists = createArrayOfLists(data);
    // console.log(arrayOfLists, 'arrayOfLists');
function convertToTitleCase(str) {
    if (!str) return str; // Handle null or undefined
    return str
        .toLowerCase() // Convert the entire string to lowercase
        .split(' ') // Split the string into an array of words
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        .join(' '); // Join the words back into a single string
}

function normalizeLabel(value) {
    if (!value) return '';
    return String(value).replace(/_/g, ' ').replace(/\s+/g, ' ').trim();
}

function getTypeLabel(type) {
    if (type === 'CUSTOMER_REFUND_PAYMENT') return 'Refund Payment';
    return convertToTitleCase(normalizeLabel(type));
}

    // console.log(JSON.stringify(data.communication), 'data log');
    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" className='pad-l-r-40 pad-b-0'>
                    <Row>
                        <Col sm="12">

                            <Table >
                                <thead>
                                    <tr>
                                        <th>{"Sent Date"}</th>
                                        <th>{"Type"}</th>
                                        <th>{"Status"}</th>
                                        <th>{"Details"}</th>
                                        {/* <th>{"JSON"}</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {arrayOfLists?.map((item, index) => (
                                        <tr key={index}>
                                            <td>{formatedDateOnly(item?.createdDate)}</td>
                                            <td>{getTypeLabel(item.type)}</td>
                                            <td>
                                                <span className={`badge badge-${['DELIVERED','SUCCESS','REFUND COMPLETED'].includes(normalizeLabel(item.status).toUpperCase())  ? "success" : ['ERROR','REFUND FAILED'].includes(normalizeLabel(item.status).toUpperCase()) ? "danger" : ['PENDING','REFUND QUEUED','REFUND IN PROGRESS','REFUND INITIATED','REFUND NOT INITIATED'].includes(normalizeLabel(item.status).toUpperCase())  ? "warning" : ""}`}>
                                                    {item.status ? item.status : 'NA'}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-xs btn-primary btn-outline"
                                                        onClick={() => viewPolicy(item)}
                                                    >
                                                        {"View"}
                                                    </button>
                                                    {item.type == 'CUSTOMER_PAYMENT' && !hasCustomerRefundPayment && isHO && isCancelledDocument && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-xs btn-warning"
                                                            disabled={submittingRefundTxnId === (item?.row?.document_transaction_history_id || item?.row?.txnid || item?.row?.txnId || 'NA')}
                                                            onClick={() => handleInitiateRefund(item)}
                                                        >
                                                            {submittingRefundTxnId === (item?.row?.document_transaction_history_id || item?.row?.txnid || item?.row?.txnId || 'NA') ? 'Initiating...' : 'Initiate Refund'}
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </Table>

                        </Col>
                    </Row>
                </Col>
            </Row>

            <ViewCommunicationDetailMessageModal isOpen={viewCommunicationDetailMessageModal} toggle={toggleViewCommunicationDetailMessageModal} communicationData={dataByType} />
            {/* <ViewCommunicationDetailWhatsappModal isOpen={viewCommunicationDetailWhatsappModal} toggle={toggleViewCommunicationDetailWhatsappModal} data={dataByType} />
            <ViewCommunicationEmailModal isOpen={viewCommunicationEmailModal} toggle={toggleViewCommunicationEmailModal} data={dataByType} />
            <ViewCommunicationModal isOpen={viewCommunicationModal} toggle={toggleViewCommunicationModal} data={dataByType} /> */}
        </Fragment>
    );
};

export default CommunicationDetails;